import { render, staticRenderFns } from "./Bookforum.vue?vue&type=template&id=10e6c386&"
import script from "./Bookforum.vue?vue&type=script&lang=js&"
export * from "./Bookforum.vue?vue&type=script&lang=js&"
import style0 from "./Bookforum.vue?vue&type=style&index=0&id=10e6c386&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports